import React from 'react';
import Popup from './component';

export default React.memo(Popup);
